<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBuildSeries } from '~/composables/build-series'
import { useOfferStore } from '~/stores/offer'

const props = defineProps<{
  buildSeries?: string
}>()

const { buildSeriesTranslation } = useBuildSeries(props.buildSeries)

const offerStore = useOfferStore()
const { blurNotSelectedVehicles } = storeToRefs(offerStore)

const { imageURL } = useBuildSeries(props.buildSeries)

const isBlur = computed<boolean>(() => offerStore.selectedOffer
  ? offerStore.selectedOffer.buildSeries !== props.buildSeries
  : true)
</script>

<template>
  <img
    :class="
      [
        isBlur && blurNotSelectedVehicles ? 'blur' : '',
        buildSeriesTranslation() ? 'max-h-[130px]' : 'h-[133px]',
      ]
    "
    :src="imageURL" :alt="`${buildSeries} image`"
  >
</template>

<style scoped lang="scss">
.blur {
  filter: blur(.3em);
}
</style>
